import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Field} from 'formik';
import LabelInfo from "../LabelInfo";
import LabelInput from "../LabelInput";
import styles from './styles.module.scss';

const FieldRadiobutton = ({
                      fieldId,
                      label = null,
                      info = null,
                      value,
                      containerStyles = null,
                      ...rest
                    }) => {
  return (
    <Field
      id={fieldId}
      name={fieldId}
      value={value}
    >
      {({ field, meta }) => (
        <label className={classnames(styles.inputContainer, containerStyles)}>
          <input
            className={classnames(styles.input, {[styles.errorBorder]: meta.error && meta.touched})}
            type={'radio'}
            {...field}
            {...rest}
            value={value}
            checked={field.value === value}
          />
          <div className={classnames(styles.outerCircle, {[styles.errorBorder]: meta.error && meta.touched})}>
            <div className={styles.innerCircle}/>
          </div>
          <div className={styles.labelContainer}>
            <LabelInput label={label} bold={false}/>
          </div>
        </label>
      )}
    </Field>
  )
};

FieldRadiobutton.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  label: PropTypes.node,
  info: PropTypes.node,
  containerStyles: PropTypes.string,
};

export default FieldRadiobutton;
